<template>
  <div
      class="loading-overlay"
      v-if="show"
      :class="{ 'visible': show, 'small': small }"
  >
    <div class="spinner-container">
      <div class="spinner" :class="{ 'small': small }"></div>
    </div>
    <p v-if="message" class="loading-message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: '正在準備你的文件...'
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    // Force a browser repaint to ensure immediate visibility
    if (this.show) {
      window.requestAnimationFrame(() => {
        if (this.$el) {
          this.$el.style.display = 'flex';
          this.$el.style.opacity = '1';
        }
      });
    }
  }
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10000; /* Increased z-index to ensure it's above everything */
  will-change: opacity; /* Optimizes for animations */
  transform: translateZ(0); /* Force GPU acceleration */
  backface-visibility: hidden;
  -webkit-font-smoothing: antialiased;

  /* Add minimal animation to avoid janky initial display */
  opacity: 1;
  animation: fadeIn 0.15s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0.95; }
  to { opacity: 1; }
}

.loading-overlay p.loading-message {
  margin-top: 16px;
  color: #333333;
  font-size: 16px;
  text-align: center;
  max-width: 80%;
  font-weight: 500;
}

.spinner-container {
  /* Container helps with rendering optimization */
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 3px solid rgba(255, 158, 21, 0.2);
  border-top-color: #FF9E15;
  border-radius: 50%;

  /* Use optimized animation properties */
  animation: spin 1s linear infinite;
  will-change: transform;
  transform: translateZ(0);
}

.spinner.small {
  width: 24px;
  height: 24px;
  border-width: 2px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 480px) {
  .loading-overlay p.loading-message {
    font-size: 14px;
    padding: 0 20px;
  }

  .spinner-container {
    width: 40px;
    height: 40px;
  }

  .spinner {
    width: 40px;
    height: 40px;
  }

  .spinner.small {
    width: 20px;
    height: 20px;
  }
}
</style>